/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/9/2020
 */
import mergeProps from "@/router/utils/mergeProps";

let FormMain = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/modules/coach/Resources/Forms/FormMain.vue')
let EmptyRouterView = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/components/EmptyRouterView.vue')
import formQuestionsAnswersRoutes from './formQuestionsAnswersRoutesFn'

export default [
	{
		path: 'forms/:formId',
		component: EmptyRouterView,
		meta:{
			resourceTab: "forms",
		},
		props: mergeProps,
		...formQuestionsAnswersRoutes(FormMain, 'ResourcesFormDetails'),


	},

]

